<script lang="ts">
  export let badge: 'app-store' | 'google-play' = 'app-store'

  let properties = {
    src: '/images/app-store-badge.webp',
    alt: 'App store badge',
    href: 'https://apps.apple.com/app/id1078037686',
  }

  $: {
    if (badge === 'google-play') {
      properties = {
        src: '/images/google-play-badge.webp',
        alt: 'Google play badge',
        href: 'https://play.google.com/store/apps/details?id=com.brucepass.bruce',
      }
    }
  }
</script>

<a href={properties.href} target="_blank" rel="noreferrer">
  <img src={properties.src} alt={properties.alt} />
</a>

<style lang="scss">
  a {
    width: 150px;
    height: 45px;

    img {
      width: 100%;
      height: 100%;
    }
  }
</style>
